import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import FullViewportContainer from './FullViewportContainer';
import { SANS_SERIF, typographyType } from '../propTypes';
import theme from '../styles/theme';
import {
  getSliceCopy,
  getSliceStretch,
  getSliceTypography,
} from '../selectors';

const simple = (classes, copy, className) => (
  <h2 className={cn(className, classes.dividingLine)}>
    {copy}
  </h2>
);

const wrapped = (classes, copy, className) => (
  <FullViewportContainer>
    <h2 className={cn(className, classes.dividingLine)}>
      {copy}
    </h2>
  </FullViewportContainer>
);

const TextDivider = ({
  classes,
  className,
  copy,
  stretch,
}) => (
  stretch !== 'No' ? wrapped(classes, copy, className) : simple(classes, copy, className)
);

TextDivider.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  copy: PropTypes.string,
  stretch: PropTypes.string,
  typography: typographyType,
};

TextDivider.defaultProps = {
  copy: undefined,
  className: undefined,
  stretch: 'No',
  typography: SANS_SERIF,
};

const mapStateToProps = (state, { sliceId, copy }) => ({
  copy: getSliceCopy(state, sliceId) || copy,
  stretch: getSliceStretch(state, sliceId),
  typography: getSliceTypography(state, sliceId),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    dividingLine: {
      margin: 0,
      padding: '32px 0 16px 0',
      fontFamily: ({ typography }) => (
        typography === SANS_SERIF ? theme.fonts.bold : theme.fonts.heading
      ),
      fontSize: '24px',
      textTransform: 'uppercase',
      letterSpacing: 0,
      lineHeight: 1.5,
      textAlign: 'center',
      overflow: 'hidden',
      '&:before, &:after': {
        backgroundColor: theme.colors.dividingLine,
        display: 'inline-block',
        height: '1px',
        position: 'relative',
      },
      '&:before': {
        width: '100%',
        verticalAlign: 'top',
        content: '""',
      },
      [theme.breakpoints.up('md')]: {
        '&:before, &:after': {
          content: '""',
          verticalAlign: 'middle',
          width: '50%',
        },
        '&:before': {
          marginLeft: '-50%',
          right: '16px',
        },
        '&:after': {
          marginRight: '-50%',
          left: '16px',
        },
      },
    },
  }),
)(TextDivider);
